import { FunctionComponent, useCallback } from "react";

import Button from "@src/modules/shared/components/Button";
import { BaseModalWrapperProps } from "@src/modules/shared/components/Modal/BaseModalWrapper";
import {
  ConfirmationModalButtons,
  ConfirmationModalWrapper,
  ConfirmModalDescription,
} from "@src/modules/shared/components/Modal/ConfirmationModal/ConfirmationModal.components";
import useModal from "@src/modules/shared/components/Modal/useModal";

interface Props extends BaseModalWrapperProps {
  header: string;
  description?: string;
  cancelButtonLabel?: string;
  confirmButtonLabel: string;
  isDeleteConfirmation?: boolean;
  onConfirm: () => void;
  onCancel?: () => void;
}

const ConfirmationModal: FunctionComponent<Props> = (props) => {
  const { closeModal } = useModal();
  const {
    header,
    description,
    cancelButtonLabel,
    confirmButtonLabel,
    isDeleteConfirmation,
    onConfirm,
    onCancel,
    ...modalProps
  } = props;

  const handleConfirm = useCallback(() => {
    onConfirm();
    closeModal();
  }, [onConfirm, closeModal]);
  const handleCancel = useCallback(() => {
    if (onCancel) onCancel();
    closeModal();
  }, [onCancel, closeModal]);

  return (
    <ConfirmationModalWrapper {...modalProps}>
      {header}
      {description && (
        <ConfirmModalDescription>{description}</ConfirmModalDescription>
      )}
      <ConfirmationModalButtons>
        {cancelButtonLabel && (
          <Button buttonType="secondary" onClick={handleCancel}>
            {cancelButtonLabel}
          </Button>
        )}
        <Button
          buttonType={isDeleteConfirmation ? "delete" : "primary"}
          onClick={handleConfirm}
          data-cy="confirm-modal"
        >
          {confirmButtonLabel}
        </Button>
      </ConfirmationModalButtons>
    </ConfirmationModalWrapper>
  );
};

export default ConfirmationModal;
